import gql from 'graphql-tag'
import moneyFragment from '~/graphql/fragments/money'

export const ticketAlertFragment = gql`
  fragment alert on TicketAlert {
    id
    event {
      id
      slug
    }
    eventType {
      id
      slug
      title
    }
    maximumPrice {
      ...money
    }
  }
  ${moneyFragment}
`

export const GET_ACTIVE_TICKET_ALERTS = gql`
  query getActiveTicketAlerts {
    viewer {
      id
      activeTicketAlerts {
        ...alert
      }
    }
  }
  ${ticketAlertFragment}
`
